import React, { useState, useEffect } from 'react';

const BounceMailUpdate = ({ fromEmails }) => {
  const [formData, setFormData] = useState({
    BUName: '',
    lastUpdatedDate: '',
  });

  const [buNames, setBuNames] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;
  const BUId = sessionStorage.getItem("BUId");

  useEffect(() => {
    const fetchBUNameData = async () => {
      try {
        const response = await fetch(`${apiUrl}/Mailer/GetSMTPMails?BUId=${BUId}`);
        const data = await response.json();
        console.log("data:", data);
        setBuNames(data);
      } catch (error) {
        console.error('Error fetching BU Names:', error);
      }
    };

    if (BUId) {
      fetchBUNameData();
    }
  }, [BUId]);  // Dependency on BUId so it triggers if BUId changes

  // Function to fetch last updated date for the selected email
  const fetchLastUpdatedDate = async (email) => {
    try {
      const response = await fetch(`${apiUrl}/Mailer/GetLastUpdatedDate?BUId=${BUId}&MailId=${email}`);
      
      // Check if the response is plain text
      const contentType = response.headers.get('Content-Type');
      if (contentType && contentType.includes('text/plain')) {
        const rawText = await response.text(); // Read the body as text
        console.log('Raw response text (date):', rawText);
        setFormData((prev) => ({
          ...prev,
          lastUpdatedDate: rawText || 'N/A',
        }));
      } else {
        console.error('Unexpected response type, expected text/plain:', contentType);
        setFormData((prev) => ({
          ...prev,
          lastUpdatedDate: 'Unexpected response format',
        }));
      }
    } catch (error) {
      console.error('Error fetching last updated date:', error);
      setFormData((prev) => ({
        ...prev,
        lastUpdatedDate: 'Error fetching date',
      }));
    }
  };
  
  const handleDropdownChange = (e) => {
    const selectedEmail = e.target.value;
    setFormData((prev) => ({
      ...prev,
      BUName: selectedEmail,
    }));

    // Fetch the last updated date when an email is selected
    if (selectedEmail) {
      fetchLastUpdatedDate(selectedEmail);
    } else {
      setFormData((prev) => ({
        ...prev,
        lastUpdatedDate: '',
      }));
    }
  };

  const handleImport = async () => {
    const { BUName } = formData;
    if (!BUName) {
      alert("Please select a valid email address.");
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/Mailer/SaveSMTPBounceMails?BUId=${BUId}&MailId=${BUName}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          BUName,
          BUId,
        }),
      });

      if (response.ok) {
        //const result = await response.json();
        console.log('Update successful:', response);
        alert('Update successful!');
      } else {
        console.error('Failed to update:', response.statusText);
        alert('Update failed. Please try again later.');
      }
    } catch (error) {
      console.error('Error making API call:', error);
      alert('An error occurred while updating. Please try again.');
    }
  };

  // Ensure fromEmails is defined and not null before calling map
  const emails = fromEmails && Array.isArray(fromEmails) ? fromEmails : [];

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900">UPDATE SMTP BOUNCE MAILS</h1>
        </div>

        <form className="space-y-6 bg-white p-8 rounded-lg shadow">
          {/* Dropdown for From Emails */}
          <div>
            <label htmlFor="BUName" className="block text-sm font-medium text-gray-700">
              Select Mail
            </label>
            <select
              id="BUName"
              name="BUName"
              value={formData.BUName}
              onChange={handleDropdownChange}
              className="mt-1 block w-full rounded-md border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            >
              <option value="">Select Mail</option>
              {/* Loop through the fetched BU names */}
              {buNames.map((buNameObj, index) =>
                buNameObj.fromEmails && Array.isArray(buNameObj.fromEmails) ?
                  buNameObj.fromEmails.map((email, emailIndex) => (
                    <option key={`${index}-${emailIndex}`} value={email}>
                      {email}
                    </option>
                  ))
                : null
              )}
            </select>
          </div>

          {/* Readonly Textbox for LastupdatedDate */}
          <div>
            <label htmlFor="LastupdatedDate" className="block text-sm font-medium text-gray-700">
              Last Updated Date
            </label>
            <input
              type="text"
              id="LastupdatedDate"
              name="LastupdatedDate"
              value={formData.lastUpdatedDate}
              readOnly
              className="mt-1 block w-full rounded-md border-gray-300 bg-gray-100 px-3 py-2 focus:outline-none"
            />
          </div>

          {/* Import Button */}
          <div className="flex justify-end">
            <button
              type="button"
              onClick={handleImport}
              className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-lg transition-colors"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BounceMailUpdate;
